import React, { useState, useEffect, useContext } from 'react';

// Context
import { NavigationContext } from '../../../context/navigation-context';
import { LangContext } from '../../../context/lang-context';
import { NotificationContext } from '../../../context/notification-context';

// Custom hooks
import useHttp from '../../../hooks/use-http';

// Components
import Table from '../../../components/Table';
import Modal from '../../../components/Modal';
import Code from '../../../components/Definitions/Code';
import NoResults from '../../../components/NoResults/NoResults'
import useFetch from '../../../hooks/fetchMSSQL-hook';

const Codes = () => {
    const navigationCtx = useContext(NavigationContext);
    const notificationCtx = useContext(NotificationContext);
    const { TRL_Pack } = useContext(LangContext);
    const {fetchMssqlApi} = useFetch();

    const [codes, setCodes] = useState([]);
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [inputValues, setInputValues] = useState({
        ean: ''
    });
    const [suggestions, setSuggestions] = useState([]);

    // const [modifiedUserId, setModifiedUserId] = useState(null);

    const getProducts = () => {fetchMssqlApi('products', { method: "POST", hideNotification: true, data: {}}, response => setProducts(response))}
    const getCodes = () => {fetchMssqlApi('payment-codes', { method: "GET", hideNotification: true }, response => setCodes(response?.data ?? response ?? []));};

    useEffect(() => {
        navigationCtx.setHeaderData({ text: TRL_Pack.navbar.codes })
        getCodes();
        getProducts();
    }, []);

    const showModalHandler = () => {
        setShowModal(true);
    };

    const hideModalHandler = () => setShowModal(false);

    const getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        const suggestions = inputLength === 0 ? [] : products.filter(product =>
            product.Name.toLowerCase().slice(0, inputLength) === inputValue
        );

        setSuggestions(suggestions);
    };

    const changeHandler = e => {
        const { name, value } = e.target;

        getSuggestions(value);

        setInputValues(prevState => ({
            ...prevState,
            [name]: value
        }))
    };

    const submitHandler = e => {
        e.preventDefault();
        const selectedProduct = products.find(product => product.EAN === Number(inputValues.ean));
        // Validation
        if (!inputValues.ean || !selectedProduct) {
            notificationCtx.notification('error', TRL_Pack.errors.invalidInput);
            return;
        }
        const data = {
            Ean: inputValues.ean
        };

        addCodeHandler(data);
    }

    const deleteCodeHandler = id => {
        fetchMssqlApi(`payment-code/${id}`, { method: "DELETE" }, () => {
            setCodes(prev => prev.filter(code => code.PaymentCodeId !== id));
        });
    };

    const addCodeHandler = data => {
        fetchMssqlApi('payment-code', { method: "POST", data }, response => {
            hideModalHandler();

            const newRow = response?.rows?.[0] ?? response?.data?.rows?.[0] ?? response?.[0];
            if (!newRow) return;

            setCodes(prev => [newRow, ...prev]);
        });
    };

    return (
        <div className='card mt-3'>
            {codes.length > 0 ? (<>
                <div className='card-header'>
                    <button
                        className="d-block btn text-nowrap btn-outline-secondary text-decoration-none ml-auto my-2 mr-1"
                        onClick={showModalHandler}
                    >
                        <i className="fas fa-plus" />
                    </button>
                </div>
                <Table>
                    <thead>
                        <tr className='text-center pe-none headers-color'>
                            <th>{TRL_Pack.codes.code}</th>
                            <th>{TRL_Pack.codes.ean}</th>
                            <th>{TRL_Pack.codes.productName}</th>
                            <th>{TRL_Pack.codes.status}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className='text-center'>
                        {codes.map(code => <Code
                            key={code.PaymentCodeId}
                            id={code.PaymentCodeId}
                            paymentCode={code.PaymentCode}
                            ean={code.EAN}
                            productName={code.Name}
                            status={code.Status}
                            deleteCodeHandler={deleteCodeHandler} />)}
                    </tbody>
                </Table>
            </>) : (
                <NoResults buttonText={TRL_Pack.codes.add} onClick={showModalHandler} />
            )}
            {showModal && <Modal
                hideModalHandler={hideModalHandler}
                header={'Dodaj kod płatniczy'}
            >
                <form onSubmit={submitHandler} id='modal-form'>
                    <div className='form-group'>
                        <label className='h6'>{TRL_Pack.codes.ean}</label>
                        <input
                            type='text'
                            name='ean'
                            className='form-control'
                            onChange={changeHandler}
                            value={inputValues.ean}
                            list='suggestions'
                            autoComplete='off'
                            placeholder={TRL_Pack.codes.eanPlaceholder}
                            required
                        />
                        <datalist id='suggestions'>
                            {suggestions.map(suggestion => <option key={suggestion.EAN} value={suggestion.EAN}>{suggestion.Name}</option>)}
                        </datalist>
                    </div>
                </form>
            </Modal>}
        </div>);
};

export default Codes;